import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'lib-data-import-edit-mail-modal',
  templateUrl: './data-import-edit-mail-modal.component.html',
  styles: []
})
export class DataImportEditMailModalComponent extends ExcTranslation implements OnInit {
  recipients: {Mail: ''}[] = [];
  allowNull = false;
  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
  }
  ngOnInit() {
    this.recipients = [];
    let r = this.overlayConfig.data.Recipients;
    this.allowNull = this.overlayConfig.data.AllowNull || false;
    if (r !== null && r.length > 0) {
      r = r.replace(';', ',');
      for (const x of r.split(',')) {
        this.recipients.push({Mail: x});
      }
    } else {
      this.recipients.push({Mail: ''});
    }
  }
  proceed() {
    let x = '';
    for (const c of this.recipients) {
      if (x !== '') {
        x = x + ',' + c.Mail;
      } else {
        x = c.Mail;
      }
    }
    this.overlayRef.close({proceed: true, Recipients: x});
  }
  canAdd() {
    if (this.recipients.length === 0) {
      return true;
    } else {
      if (this.recipients[this.recipients.length - 1].Mail !== '') {
        return true;
      }
      return false;
    }
  }
  isValid() {
    if (this.allowNull === true) {
      if (this.recipients.length === 0) {
        return true;
      }
      if (this.recipients.length === 1 && this.recipients[this.recipients.length - 1].Mail === '') {
        return true;
      }
      for (const x of this.recipients) {
        if (this.regexp.test(x.Mail) === false) {
          return false;
        }
      }

      return true;
    } else {
      if (this.recipients.length === 0) {
        return false;
      }
      if (this.recipients[this.recipients.length - 1].Mail === '') {
        return false;
      }
      for (const x of this.recipients) {
        if (this.regexp.test(x.Mail) === false) {
          return false;
        }
      }
      return true;
    }
  }
}
